import * as React from 'react'
import cx from 'classnames'
import styles from './Help.m.sass'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  help?: React.ReactNode
  error?: string
}

export default function Help({ error, help, className, ...props }: Props) {
  return error || help ? (
    <span
      className={cx(styles.help, className, error && styles.danger)}
      {...props}
    >
      {error || help}
    </span>
  ) : null
}
